module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-4-7446e7d0e50605830ca31a33ca8c7a96.jpg";